const React = require('react');
const throttle = require("mn-utils/throttle");
const {List} = require("react-virtualized/dist/commonjs/List");
const {AutoSizer} = require("react-virtualized/dist/commonjs/AutoSizer");
const withState = require("../../../utils/withState");
const {location$, replaceLocation} = require("../../../router");

module.exports = withState((setState) => {
  let _stop;
  let _locked = 1;
  const updateParam = throttle((args) => {
    if (_stop) {
      return;
    }
    const loc = location$.getValue();
    replaceLocation({
      path: loc.path,
      query: {
        ...loc.query,
        s: args,
      },
    });
  });

  return (state, props) => {
    const {
      showUp,
    } = state;
    const Item = props.Item;
    const items = props.list || [];
    const length = items.length || 0;

    return (
      <AutoSizer className="sq-i">
        {({height, width}) => {
          console.log(items, length);

          return (
            <List
              height={height}
              width={width}
              rowCount={length}
              rowHeight={70}
              scrollTop={state.scrollTop}
              onScroll={({scrollTop}) => {
                if (_locked) {
                  return;
                }
                setState({
                  scrollTop,
                });
                updateParam([scrollTop, length]);
              }}
              onRowsRendered={({overscanStartIndex}) => {
                const _showUp = overscanStartIndex > 5;
                showUp === _showUp || setState({
                  showUp: _showUp,
                });
              }}
              rowRenderer={({key, index, style}) => {
                const item = items[index];
                return (
                  <div
                    className="layoutRow fvaC"
                    key={key || (item ? item.id : index)}
                    style={style}
                  >
                    <Item
                      data={item}
                      index={index}
                    />
                  </div>
                );
              }}
              noRowsRenderer={() => (
                <div
                  className="layoutRow fvaC"
                >
                  <div className="f16 fw4 mt20 ttU tc w">No data</div>
                </div>
              )}
            />
          );
        }}
      </AutoSizer>
    )
  }
})